import {
  Modal,
  ModalContent,
  ModalHeader,
  ModalBody,
  Spinner,
  Table,
  TableHeader,
  TableColumn,
  TableBody,
  TableRow,
  TableCell,
  Button,
  Avatar,
  Select,
  SelectItem
} from '@heroui/react';
import TimeAgo from 'react-timeago';
import { useGetOrgInfo } from '../hooks/useGetOrgInfo';

const OrgMemberList = ({user, dismissModal, orgId}) => {
  const [org, updateOrg] = useGetOrgInfo(orgId);
  const roles = {admin: 'coadmin', member: 'member'};

  const changeRole = async (data, member) => {
    const d = await fetch(`/api/v1/organizations/${orgId}/members/${member._id}/${data['currentKey'] === 'member' ? 'demote' : 'promote'}`,
      {method: 'PUT'});
    const djson = await d.json();
    if (djson['organization']) {
      updateOrg(djson['organization']);
    }
  }

  const removeMember = async (member) => {
    if (window.confirm(`Are you sure that you want to remove member ${member.invite_email}?`)) {
      const remove = await fetch(`/api/v1/organizations/${orgId}/members/${member._id}`, {method: 'DELETE'});
      const rjson = await remove.json();
      if (rjson['organization']) {
        updateOrg(rjson['organization']);
      }
    }
  };

  const memberSort = (a,b) => {
    if (a['user']['email'] > b['user']['email']) {
      return 1;
    } else {
      return -1;
    }
  }

  const userIsOrgAdmin = () => {
    if (user?.admin) {
      return true;
    }
    if (user?.active_organization_id === orgId) {
      const myMember = user.active_organization?.member;
      if (myMember && (myMember.role === 'admin' || myMember.role === 'coadmin')) {
        return true;
      }
    }
    return false;
  };

  return (
    <Modal size='6xl' style={{maxWidth: '98vw', maxHeight: '90vh', position: 'fixed'}} isOpen={true} isDismissable={true} onClose={dismissModal}>
      <ModalContent>
        <ModalHeader className='flex flex-col gap-1'>
          Org {org?.name}
        </ModalHeader>
        <ModalBody>
          { (org && org.members) ?
            <Table classNames={{base: 'act-t-base', table: 'act-t-table'}} isHeaderSticky shadow='md' isStriped>
              <TableHeader style={{height: '0px', color: '#202020'}}>
                { (user?.admin || user?.active_organization_id === orgId)
                  && <TableColumn style={{color: '#f0f0f0', backgroundColor: '#19b2c3', width: '100px'}}></TableColumn>
                }
                <TableColumn style={{color: '#f0f0f0', backgroundColor: '#19b2c3'}}>User</TableColumn>
                <TableColumn style={{color: '#f0f0f0', backgroundColor: '#19b2c3', minWidth: '130px'}}>Role</TableColumn>
                <TableColumn style={{color: '#f0f0f0', backgroundColor: '#19b2c3', width: '200px'}}>Joined</TableColumn>
                <TableColumn style={{color: '#f0f0f0', backgroundColor: '#19b2c3', width: '200px'}}>Last Active</TableColumn>
                <TableColumn align='center' style={{color: '#f0f0f0', backgroundColor: '#19b2c3', width: '120px'}}>Campaigns</TableColumn>
                <TableColumn align='center' style={{color: '#f0f0f0', backgroundColor: '#19b2c3', width: '120px'}}>Emails sent</TableColumn>
                <TableColumn align='center' style={{color: '#f0f0f0', backgroundColor: '#19b2c3', width: '120px'}}>Clicks</TableColumn>
              </TableHeader>
              <TableBody items={org?.members?.sort(memberSort)} style={{overflow: 'scroll', maxHeight: '520px'}}>
                { (member) => (<TableRow key={member.id || member._id}>
                      { (userIsOrgAdmin() && member.user_id !== user?.id && member.role !== 'admin')
                        ? <TableCell style={{color: '#202020'}}>
                            <Button color='warning' onPress={() => removeMember(member)}>Remove</Button>
                          </TableCell>
                        : <TableCell style={{color: '#202020'}}></TableCell>
                      }
                      <TableCell style={{color: '#202020'}}>
                        <div style={{display: 'flex', flexDirection: 'row', alignItems: 'center', width: 'max-content'}}>
                          { <Avatar isBordered as='div'
                                    src={member.user?.avatar} name={member.user?.email?.split('')[0].toUpperCase()}
                                    style={{fontSize: '28px', color: member.role === 'invited' ? '#f0f0f0' : '#4090a5', marginRight: '12px'}}
                                    color={member.role !== 'invited' ? 'success' : 'warning'} />
                          }
                          {member.user?.email}
                        </div>
                      </TableCell>
                      <TableCell style={{color: '#202020'}}>
                        { ( userIsOrgAdmin() && member.role !== 'admin' && member.role !== 'invited' )
                          ?  <Select onSelectionChange={(d) => changeRole(d, member)} selectedKeys={[member.role]}>
                              { Object.keys(roles).map(r => <SelectItem textValue={r} key={roles[r]}>{r}</SelectItem>) }
                             </Select>
                          :
                          member.role === 'admin' ? 'owner' : member.role === 'coadmin' ? 'admin' : member.role
                        }
                      </TableCell>
                      <TableCell style={{color: '#202020'}}>{new Date(member.created_at).toDateString().split(' ').slice(1, 4).join(' ')}</TableCell>
                      <TableCell style={{color: '#202020'}}><TimeAgo date={new Date(member.user?.updated_at)} /></TableCell>
                      <TableCell style={{color: '#202020'}}>{member.campaign_count}</TableCell>
                      <TableCell style={{color: '#202020'}}>{parseInt(member.email_count).toLocaleString()}</TableCell>
                      <TableCell style={{color: '#202020'}}>{parseInt(member.click_count).toLocaleString()}</TableCell>
                    </TableRow>
                  )
                }
              </TableBody>
            </Table>
            : <Spinner />
          }
        </ModalBody>
      </ModalContent>
    </Modal>
  );
}

export default OrgMemberList;
